/** 格式化金额：小于 0.01 显示美分，否则美元 */
export function formatCost(v: number): string {
  if (!Number.isFinite(v) || v < 0) return "$0.00";
  return v < 0.01 ? `${(v * 100).toFixed(2)}¢` : `$${v.toFixed(2)}`;
}
